/** Static "about" page. */
import React from "react";
import { Box, Typography, Stack, Paper, Chip, Button } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import InsightsIcon from "@mui/icons-material/Insights";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { Link as RouterLink } from "react-router-dom";

function About() {
  return (
    <Box sx={{ width: "100%", maxWidth: "1150px", px: 2, mx: "auto", mt: 3, mb: 4 }}>
      <Stack
        sx={{
          width: "100%",
          py: 2,
          borderRadius: 3,
          background: "linear-gradient(135deg, #f5f6f8 0%, #ecedf1 100%)",
          border: "1px solid #dde1e7",
        }}
      >
        <Box sx={{ px: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            About Oraclase
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Autonomous laser material processing with AI-assisted parameter tuning.
          </Typography>
        </Box>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          mt: 3,
          borderRadius: 3,
          border: "1px solid #e7ebf3",
          backgroundColor: "#ffffff",
          p: { xs: 2, md: 3 },
        }}
      >
        <Stack spacing={2}>
          <Typography variant="body1" color="text.secondary">
            Tuning laser process parameters traditionally requires expensive trial-and-error cycles.
            Oraclase uses artificial intelligence, computer vision, and data-driven algorithms to simplify
            this workflow and make parameter identification more repeatable across laser systems and substrates.
          </Typography>

          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Chip icon={<AutoAwesomeIcon />} label="AI-driven optimization" variant="outlined" />
            <Chip icon={<PrecisionManufacturingIcon />} label="Any laser + material combination" variant="outlined" />
            <Chip icon={<InsightsIcon />} label="Cloud software workflow" variant="outlined" />
          </Stack>

          <Typography variant="h6" sx={{ fontWeight: 600, mt: 1 }}>
            What you can do in this platform
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              <strong>Color Explorer:</strong> identify robust process parameters to achieve target colors with
              suitable resolution.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Color Reproduction:</strong> transform selected color data into marking files for image-like
              laser reproduction.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Color Selection:</strong> compare and filter explored color results to support practical
              process decisions.
            </Typography>
          </Stack>

          <Typography variant="body2" color="text.secondary">
            Oraclase is based in Saarbruecken, Germany, and works with industrial partners across laser
            machine manufacturing and laser-based production domains.
          </Typography>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} pt={1}>
            <Button
              variant="contained"
              startIcon={<ContactMailIcon />}
              component={RouterLink}
              to="/contact"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 700 }}
            >
              Contact Support
            </Button>
            <Button
              variant="outlined"
              component="a"
              href="https://www.oraclase.com/"
              target="_blank"
              rel="noreferrer"
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Visit Oraclase Website
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}

export default About;
